import styled from "styled-components";
import { mobile, tablet } from "../responsive";
import { FormattedMessage } from "react-intl";

const Container = styled.div`
    background: linear-gradient(135deg, #f0f9f4 0%, #e8f5e8 100%);
    min-height: 100vh;
    padding: 0;
    overflow: hidden;
`;

const HeroSection = styled.div`
    background: linear-gradient(135deg, #2d5a27 0%, #4a7c59 50%, #6b9b6b 100%);
    color: white;
    padding: 8rem 2rem 6rem;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="10" cy="60" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="90" cy="40" r="0.5" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
        opacity: 0.3;
    }

    ${mobile({ 
        padding: "6rem 1rem 4rem",
    })}
    ${tablet({ 
        padding: "7rem 1.5rem 5rem",
    })}
`;

const HeroContent = styled.div`
    position: relative;
    z-index: 2;
    max-width: 800px;
    margin: 0 auto;
`;

const Title = styled.h1`
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
    letter-spacing: -0.02em;

    ${mobile({ 
        fontSize: "2.5rem",
        marginBottom: "1rem",
    })}
    ${tablet({ 
        fontSize: "3rem",
        marginBottom: "1.2rem",
    })}
`;

const Subtitle = styled.h2`
    font-size: 1.8rem;
    font-weight: 400;
    margin-bottom: 2rem;
    opacity: 0.95;
    line-height: 1.4;

    ${mobile({ 
        fontSize: "1.4rem",
        marginBottom: "1.5rem",
    })}
    ${tablet({ 
        fontSize: "1.6rem",
        marginBottom: "1.8rem",
    })}
`;

const Description = styled.p`
    font-size: 1.2rem;
    font-weight: 300;
    opacity: 0.9;
    line-height: 1.6;
    max-width: 600px;
    margin: 0 auto;

    ${mobile({ 
        fontSize: "1rem",
    })}
    ${tablet({ 
        fontSize: "1.1rem",
    })}
`;

const ContentSection = styled.div`
    padding: 6rem 2rem;
    max-width: 1200px;
    margin: 0 auto;

    ${mobile({ 
        padding: "4rem 1rem",
    })}
    ${tablet({ 
        padding: "5rem 1.5rem",
    })}
`;

const ContentCard = styled.div`
    background: white;
    border-radius: 20px;
    padding: 3rem;
    margin-bottom: 3rem;
    box-shadow: 0 10px 30px rgba(45, 90, 39, 0.1);
    border: 1px solid rgba(107, 155, 107, 0.2);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(90deg, #2d5a27, #4a7c59, #6b9b6b);
    }

    ${mobile({ 
        padding: "2rem",
        marginBottom: "2rem",
        borderRadius: "15px",
    })}
    ${tablet({ 
        padding: "2.5rem",
        marginBottom: "2.5rem",
    })}
`;

const ContentText = styled.p`
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1.7;
    color: #2d3748;
    margin: 0;

    ${mobile({ 
        fontSize: "1.1rem",
        lineHeight: "1.6",
    })}
    ${tablet({ 
        fontSize: "1.2rem",
    })}
`;

const DecorativeElement = styled.div`
    position: absolute;
    width: 200px;
    height: 200px;
    background: linear-gradient(45deg, rgba(107, 155, 107, 0.1), rgba(45, 90, 39, 0.1));
    border-radius: 50%;
    top: -100px;
    right: -100px;
    z-index: 1;

    ${mobile({ 
        width: "150px",
        height: "150px",
        top: "-75px",
        right: "-75px",
    })}
`;

const About = () => {
    return (
        <>
            <Container>
                <HeroSection>
                    <HeroContent>
                        <Title>
                            <FormattedMessage id="about_title" defaultMessage="About Air Vitamin" />
                        </Title>
                        <Subtitle>
                            <FormattedMessage id="about_subtitle" defaultMessage="Your Essential Health Partner for Modern Living" />
                        </Subtitle>
                        <Description>
                            <FormattedMessage id="about_description" defaultMessage="Discover the story behind our innovative health solutions and our commitment to your well-being." />
                        </Description>
                    </HeroContent>
                </HeroSection>

                <ContentSection>
                    <ContentCard>
                        <DecorativeElement />
                        <ContentText>
                            <FormattedMessage id="about_1" defaultMessage="" />
                        </ContentText>
                    </ContentCard>
                    
                    <ContentCard>
                        <DecorativeElement />
                        <ContentText>
                            <FormattedMessage id="about_2" defaultMessage="" />
                        </ContentText>
                    </ContentCard>
                </ContentSection>
            </Container>
        </>
    );
};

export default About;
